import { Box, Typography, Grid, Button } from "@mui/material";
import header from "../../assets/landing-page/header.jpg";
import about from "../../assets/landing-page/about.jpg";
import guidelines from "../../assets/landing-page/guidelines.jpg";
import contact from "../../assets/landing-page/contact.jpg";
import enhancementRequest from "../../assets/landing-page/r4k079682_rrd.png";
import "./homeLand.css";
import { useEffect, useState } from "react";

// EDI Enhancement Request PowerApps form.
const ENHANCEMENT_REQUEST_URL =
  "https://apps.powerapps.com/play/e/d985d578-48a2-ed72-8776-1a3098dba701/a/da883461-581c-416a-a084-65a429d28106?tenantId=39b03722-b836-496a-85ec-850f0957ca6b&hint=eed789f0-3abc-4828-9c4b-f13d3f380b0c&source=sharebutton&sourcetime=1790101712061";


const HomeLanding = (userId) => {
  const [contactUsUrl, setContactUsUrl] = useState("");

  useEffect(() => {
    setContactUsUrl(
      `${process.env.REACT_APP_JDSN_CONTACT_US_BASE_URL}/?APPID=EDI&USERID=${userId.userId}`
    );
  }, [userId]);

  return (
    <>
      <div p={4}>
        <div style={{ paddingTop: "10px" }}>
          <div className="image-container">
            <img alt="HomeLanding" height="315px" src={header} width="100%" />
            <div className="shade"></div>
          </div>
          <div
            style={{
              position: "absolute",
              transform: "translate(16%, -200%)",
              textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
            }}
          >
            <Typography
              gutterBottom
              variant="h1"
              component="h1"
              style={{ color: "white" }}
            >
              Supply Chain Streamlined: <br /> Explore EDI Solutions
            </Typography>
          </div>
        </div>
        <div>
          <Grid container>
            <Grid item size={6}>
              <Box pt={4} pr={4}>
                <a>
                  <img alt="About" height="265px" src={about} width="100%" />
                </a>
              </Box>
            </Grid>
            <Grid item size={6}>
              <Box p={4}>
                <Typography
                  gutterBottom
                  variant="h1"
                  component="h1"
                  pt={5}
                  style={{ fontWeight: 800, fontSize: "1.9rem" }}
                >
                  About EDI
                </Typography>
                <Typography variant="body1" pt={15} mr={15} fontWeight="400">
                  EDI, or Electronic Data Interchange, is a technology-driven
                  solution that enables the seamless exchange of business
                  documents between companies.
                </Typography>
                <Button
                  size="medium"
                  variant="primary"
                  style={{ 
                    marginTop: "32px",
                    backgroundColor: "#ebd534",
                    color:"black"
                           
                   }}
                  href="https://deere.sharepoint.com/sites/dpmsm/SitePages/Digital-Communications.aspx"
                >
                  Learn More
                </Button>
              </Box>
            </Grid>
          </Grid>
        </div>
        <div pt={4}>
          <Typography gutterBottom variant="h1" component="h1" pt={5}>
            Quicks Links
          </Typography>
          <Grid container>
            <Grid item size={4}>
              <Box>
                <a href="https://jdsn.deere.com/wps/myportal/jdsn/JDSN/EDI">
                  <div className="img2-conatainer">
                    <img alt="Guide" height="200px" width="100%" src={guidelines} />
                    <div className="shade"></div>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      transform: "translate(20%, -650%)",
                      textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
                    }}
                  >
                    <Typography
                      gutterBottom
                      variant="h3"
                      component="h1"
                      style={{ color: "white" }}
                    >
                      Guidelines
                    </Typography>
                  </div>
                </a>
              </Box>
            </Grid>
            <Grid item size={4}>
              <Box>
                <a href={contactUsUrl}>
                  <div className="img2-conatainer">
                    <img alt="Contact" height="200px" width="100%" src={contact} />
                    <div className="shade"></div>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      transform: "translate(20%, -650%)",
                      textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
                    }}
                  >
                    <Typography
                      gutterBottom
                      variant="h3"
                      component="h1"
                      style={{ color: "white" }}
                    >
                      Contact Us
                    </Typography>
                  </div>
                </a>
              </Box>
            </Grid>
            <Grid item size={4}>
              <Box>
                <a
                  href={ENHANCEMENT_REQUEST_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="img2-conatainer">
                    <img
                      alt="EDI Enhancement Request"
                      height="200px"
                      width="90%"
                      src={enhancementRequest}
                    />
                    <div className="shade"></div>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      transform: "translate(16px, -650%)",
                      textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
                    }}
                  >
                    <Typography
                      gutterBottom
                      variant="h3"
                      component="h1"
                      style={{ color: "white" }}
                    >
                      EDI Enhancement Request
                    </Typography>
                  </div>
                </a>
              </Box>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default HomeLanding;
